import { useState } from 'react';

import { usePosthogCapture } from 'events/posthogCapture/_index';
import { usePosthogCapture as useSearchPosthogCapture } from 'events/posthogCapture/search';

interface UseSearchModalResult {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export default function useSearchModal(): UseSearchModalResult {
  const capture = usePosthogCapture();
  const searchCapture = useSearchPosthogCapture();
  const [isOpen, setIsOpen] = useState(false);

  const open = () => {
    capture.eventsHomeSearchClicked();
    searchCapture.opened();
    setIsOpen(true);
  };

  const close = () => setIsOpen(false);

  return { isOpen, open, close };
}
